import { IconButton, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Route, Switch, Link } from "react-router-dom";
import AppBar from "./AppBar";

import HomeIcon from "@material-ui/icons/Home";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import AllAccounts from "./AllAccounts";
import Graph from "./Graph";
import AllNews from "./AllNews";
import Profile from "./Profile";

function ManageAccount() {
  const classes = useStyles();
  const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [token, setToken] = useState();

  useEffect(() => {
    (async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        localStorage.setItem("userToken", accessToken);

        const response = await axios.get(
          "/.netlify/functions/server/api/generateToken",
          {
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
          }
        );

        // console.log("MT ", response?.data);
        setToken(response.data);
      } catch (err) {
        console.error("1 ", err.message);
      }
    })();
  }, [isAuthenticated]);

  return (
    <>
      <Link to="/allNews" className={classes.homeButton}>
        <IconButton aria-label="show 4 new accounts" color="inherit">
          <HomeIcon />
        </IconButton>
      </Link>
      <AppBar />

      <div className={classes.root}>
        <Switch>
          <Route
            path="/superAdmin/manageAccount/allAccount"
            exact
            component={() => <AllAccounts token={token} />}
          />

          <Route
            path="/superAdmin/manageAccount/reportChart"
            exact
            component={Graph}
          />
          <Route
            path="/superAdmin/manageAccount/allNews"
            exact
            component={() => <AllNews />}
          />
          <Route
            path="/superAdmin/manageAccount/profile"
            exact
            component={() => <Profile />}
          />
        </Switch>
      </div>
    </>
  );
}

export default ManageAccount;
const useStyles = makeStyles((theme) => ({
  homeButton: {
    backgroundColor: "#5c6bc0",
    borderRadius: "2rem",
    textDecoration: "none",
    position: "absolute",
    right: "1.5rem",
    bottom: "1.5rem",
    color: "inherit",
    zIndex: "10",
    "&:hover": {
      backgroundColor: "#3f51b5",
      transform: "scale(1.06)",
      color: "inherit",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "1.8rem",
      color: "white",
    },
  },
  root: {
    padding: ".3rem",
    height: "90vh",
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));
